type Capability = {
    isAvailable: boolean;
    isShown: boolean;
    label: string;
};

/*
 * This is a unified interface for getting capabilities for a user, based on Nut_Capabilities on
 * the backend.  The point of having this in one place is so that we can avoid checking
 * `window.NutCapabilities` all over the web client code.
 */
export function getCapability(capabilityName: string): Capability {
    if (typeof window === 'undefined') {
        throw new Error(
            `Unable to determine ${capabilityName} capability, because window is undefined`
        );
    }

    // @ts-expect-error
    if (!window.NutCapabilities) {
        throw new Error(
            `Unable to determine ${capabilityName} capability, because NutCapabilities is not found on window`
        );
    }

    // @ts-expect-error
    if (typeof window.NutCapabilities[capabilityName] === 'undefined') {
        throw new Error(
            `Unable to determine ${capabilityName} capability, because it is not in NutCapabilities`
        );
    }

    // @ts-expect-error
    return window.NutCapabilities[capabilityName];
}
